import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap/modal/modal-ref';
import { Component } from '@angular/core';
import { IContatto } from 'app/model/contatto';
import { FormGroup, FormControl } from '@angular/forms';


@Component({
	selector: 'app-newcontact',
	templateUrl: './newContact.html'
})
export class NewContactComponent {

	formGroup = new FormGroup({
		categoria: new FormControl(),
		cognome: new FormControl(),
		nome: new FormControl(),
		societa: new FormControl(),
		titolo: new FormControl(),
		email: new FormControl(),
		cellulare: new FormControl(),
		telefono: new FormControl(),
		fax: new FormControl(),
		citta: new FormControl(),
		indirizzo: new FormControl(),
		numciv: new FormControl(),
		pr: new FormControl(),
		cap: new FormControl()
	});
	contatto: IContatto;
	categorie = [
		'informatore',
		'collega',
		'collaboratore',
		'tecnico',
		'privato',
		'amico',
		'altro'
	];
	show = false;

	constructor(
		public activeModal: NgbActiveModal
	) {
		this.contatto = {
			id: null,
			cognome: null
		};

	}

	toggleShow() {
		this.show = !this.show;
	}
}



// WEBPACK FOOTER //
// ./src/app/rubrica/newContact/newContact.ts